export enum CurrencyCodeIso {
	EUR = "EUR",
	USD = "USD",
	PLN = "PLN",
	GBP = "GBP",
}

export function getCurrencySymbol(currency: CurrencyCodeIso) {
	switch (currency) {
		case CurrencyCodeIso.EUR:
			return "€";
		case CurrencyCodeIso.USD:
			return "$";
		case CurrencyCodeIso.PLN:
			return "zł";
		case CurrencyCodeIso.GBP:
			return "£";
	}
}
